module.exports = __webpack_public_path__ + "static/media/012.fb3a02b2.jpg";